import { useState } from 'react';

import type { Async } from '@client/new/helpers/types';

import {
  WorkoutOption,
  useAutomationWorkoutsModel,
} from '../model/AutomationWorkouts.model';
import { AutomationDetailsViewModel } from './AutomationDetails.viewModel';

export type TrialNurtureConfigViewModel = {
  selectedWorkoutId: string | null;
  /** Name of the chosen workout, or a fallback when it is not in the current search results. */
  selectedWorkoutLabel: string | null;
  confirmation: string | null;
  search: string;
  setSearch: (value: string) => void;
  options: Async<
    WorkoutOption[],
    { message: string; retry: () => Promise<void> }
  >;
  selectWorkout: (workoutId: string | null) => void;
  includePushes: boolean;
  setIncludePushes: (includePushes: boolean) => void;
  validation?: string;
};

export const useTrialNurtureConfigViewModel = (
  creatorId: number,
  details: AutomationDetailsViewModel,
): TrialNurtureConfigViewModel => {
  const [search, setSearch] = useState('');
  const options = useAutomationWorkoutsModel(creatorId, search);

  const selectedWorkoutId = details.draft.config.firstWorkoutId || null;
  const known =
    options.type === 'fetched' && selectedWorkoutId
      ? options.value.find((option) => option.id === selectedWorkoutId)
      : undefined;
  const selectedWorkoutLabel = selectedWorkoutId
    ? known?.name ?? `Workout #${selectedWorkoutId}`
    : null;

  return {
    selectedWorkoutId,
    selectedWorkoutLabel,
    confirmation: selectedWorkoutLabel
      ? `Every "your first workout" link points to ${selectedWorkoutLabel}.`
      : null,
    search,
    setSearch,
    options,
    selectWorkout: (workoutId) =>
      details.setConfig({ firstWorkoutId: workoutId ?? '' }),
    includePushes: details.draft.includePushes,
    setIncludePushes: details.setIncludePushes,
    validation: details.validation.firstWorkoutId,
  };
};
